import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'auth-logging-in',
  templateUrl: './auth-loggin-in.component.html',
  styleUrls: ['./auth-loggin-in.component.scss', '../auth.common.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthLogginInComponent {}
